import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Coverage Area route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated `DashboardLayout`. Each route provides a `meta` object with
 * the following commonly used properties:
 *
 * @typedef {Object} AreaRouteMeta
 * @property {Array<string>} modules - Application modules related to the route.
 * @property {boolean} requiresAuth - When true, route requires authentication.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/coverage-areas",
        name: "CoverageAreas",
        meta: {
            title: "Coverage Areas",
            modules: ["areas"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "areas" */ "@/modules/areas/pages/CoverageAreas"
            )
    },
    {
        path: "/coverage-areas/new",
        name: "NewArea",
        meta: {
            title: "New Area",
            modules: ["areas"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "areas" */ "@/modules/areas/pages/NewCoverageArea"
            )
    },
    {
        path: `/coverage-areas/${idParam()}`,
        name: "AreaDetails",
        meta: {
            title: "Area Details",
            modules: ["areas"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "areas" */ "@/modules/areas/pages/AreaDetails"
            )
    }
]